import React from "react";
import { Route, Switch } from "react-router";
import { Roles, withPermission } from "../../../util/PermissionProvider";
import AwardCategoryDetailPage from "./AwardCategoryDetailPage";
import AwardCategoryListingPage from "./AwardCategoryListingPage";
import AwardDetailPage from "./AwardDetailPage";
import AwardListingPage from "./AwardListingPage";
import AwardGeneralSettingPage from "./AwardGeneralSettingPage";
import AwardGeneralSettingEditPage from "./AwardGeneralSettingEditPage";

export default function AwardJuriesPages({ match }) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/general-setting`}
        component={withPermission(
          AwardGeneralSettingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/category`}
        component={withPermission(
          AwardCategoryListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/category/:id`}
        component={withPermission(
          AwardCategoryDetailPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/list`}
        component={withPermission(
          AwardListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/list/new`}
        component={withPermission(
          AwardDetailPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/list/:id`}
        component={withPermission(
          AwardDetailPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/general-setting/:id`}
        component={withPermission(
          AwardGeneralSettingEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
    </Switch>
  );
}
